import { useEffect, useRef, useState } from 'react';
import { faqItems } from '@/mocks/audios';

export default function FAQSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  const [openId, setOpenId] = useState<string | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="faq"
      ref={sectionRef}
      className="w-full py-16 md:py-24 bg-background-100"
      aria-label="Perguntas frequentes"
    >
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <span className="inline-block text-xs md:text-sm font-semibold text-accent-700 uppercase tracking-wider mb-3">
            FAQ
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Tire suas dúvidas sobre os áudios, pagamento, acesso e muito mais.
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className={`bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
                style={{ transitionDelay: `${index * 60}ms`, transitionDuration: '600ms' }}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? null : item.id)}
                  className="flex items-center justify-between w-full px-5 py-4 md:px-6 md:py-4 cursor-pointer list-none hover:bg-background-100/50 transition-colors text-left"
                  aria-expanded={isOpen}
                >
                  <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                    {item.question}
                  </span>
                  <span
                    className={`w-7 h-7 flex-shrink-0 flex items-center justify-center rounded-full transition-all ${
                      isOpen ? 'bg-accent-500 text-background-50' : 'bg-background-200'
                    }`}
                  >
                    <i
                      className={`ri-${isOpen ? 'subtract' : 'add'}-line text-sm transition-transform ${isOpen ? 'rotate-180' : ''}`}
                    />
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96' : 'max-h-0'}`}
                >
                  <div className="px-5 pb-4 md:px-6 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed pl-1 border-l-2 border-accent-300">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div
          className={`text-center mt-10 transition-all duration-700 delay-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p className="text-sm text-foreground-600 mb-3">
            Ainda tem dúvidas?
          </p>
          <a
            href="#precos"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#precos')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="hotmart-fb hotmart__button-checkout inline-flex items-center whitespace-nowrap cursor-pointer px-6 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm transition-all hover:bg-accent-600"
          >
            <i className="ri-arrow-right-line mr-2" />
            Quero Garantir Meu Acesso Agora
          </a>
        </div>
      </div>
    </section>
  );
}